import React from 'react';
import { Link } from 'react-router-dom';
import SEO, { softwareAppSchema } from '../../Components/SEO';
import SEOPageLayout from '../../Components/SEOPageLayout';

export default function ForDevelopers() {
  return (
    <SEOPageLayout>
      <SEO
        title="CheckScript for Developers — AI Code Assistant & Remote Debugging"
        description="Boost your productivity with CheckScript AI. Instant screen-to-code analysis, local Neural Driver for private enterprise coding, and low-latency remote pair programming."
        keywords="AI code assistant, developer productivity tool, remote debugging tool, AI coding helper, developer tools"
        path="/use-cases/developers"
        structuredData={softwareAppSchema()}
      />

      <section className="seo-hero seo-animate">
        <div className="seo-mesh-bg"></div>
        <div className="seo-container seo-container--sm">
          <div className="seo-hero-badge">💻 For Developers</div>
          <h1 className="seo-h1">
            Supercharge Your <span className="seo-gradient-text">Development Workflow</span>
          </h1>
          <p className="seo-lead">
            CheckScript is the ultimate utility belt for developers. Seamlessly integrate local AI inference, instant visual debugging, and sub-100ms remote collaboration into your daily routine.
          </p>
          <div className="seo-hero-actions">
            <Link to="/download" className="seo-btn seo-btn--primary">Download Host Client</Link>
          </div>
        </div>
      </section>

      <section className="seo-section seo-section--alt seo-animate">
        <div className="seo-container">
          <div className="seo-bento-grid" style={{ alignItems: 'center', gap: '48px' }}>
            <div className="seo-glass-card">
              <h3 className="seo-h3 seo-mb-24">15+ Languages Supported</h3>
              <div className="seo-bento-grid" style={{ gap: '12px' }}>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>Python</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>JavaScript</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>Hardware-accelerated capture</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>Java</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>Go</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>Rust</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>TypeScript</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>SQL</span>
                <span className="seo-label" style={{ background: 'rgba(255,255,255,0.05)', padding: '8px', borderRadius: '4px', textAlign: 'center' }}>PHP</span>
              </div>
            </div>
            <div>
              <h2 className="seo-h2">Visual Debugging & Code Generation</h2>
              <p className="seo-text-secondary seo-mb-24">
                Stop copying and pasting errors. With a simple hotkey, CheckScript scans your active IDE window, reads the stack trace or problematic code block via OCR, and provides an instant fix or explanation.
              </p>
              <p className="seo-text-secondary">
                Need to type out a solution fast? Our premium auto-typing engine simulates human keystrokes to input generated code directly into your editor, bypassing restrictive paste blocks in enterprise environments.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-section seo-animate">
        <div className="seo-container">
          <h2 className="seo-h2 seo-text-center seo-mb-48">Core Developer Workflows</h2>
          <div className="seo-bento-grid">
            <div className="seo-bento-box seo-bento-square">
              <div className="seo-card-icon seo-card-icon--amber">🔒</div>
              <h3 className="seo-h3">Private Local AI</h3>
              <p className="seo-text-secondary">
                Working on proprietary enterprise code? Use Neural Driver to run Qwen2-VL locally. Your code never leaves your machine, ensuring 100% compliance with strict corporate data policies.
              </p>
            </div>
            <div className="seo-bento-box seo-bento-square">
              <div className="seo-card-icon seo-card-icon--emerald">🚀</div>
              <h3 className="seo-h3">Remote Pair Programming</h3>
              <p className="seo-text-secondary">
                Collaborate instantly. CheckScript Remote provides a sub-100ms, Ultra-low latency streaming protocol-based remote desktop connection right in the browser. Share your IDE with a colleague without them installing any clients.
              </p>
            </div>
            <div className="seo-bento-box seo-bento-square">
              <div className="seo-card-icon seo-card-icon--cyan">📸</div>
              <h3 className="seo-h3">UI / UX Analysis</h3>
              <p className="seo-text-secondary">
                Because CheckScript uses Vision-Language models, you can capture a screenshot of your frontend UI and ask the AI to generate the corresponding CSS/HTML or identify layout bugs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-cta seo-animate">
        <div className="seo-container">
          <div className="seo-cta-box">
            <h2 className="seo-h2">Upgrade Your Dev Stack</h2>
            <p className="seo-text-secondary seo-mb-32">Integrate CheckScript into your workflow for unparalleled productivity.</p>
            <Link to="/download" className="seo-btn seo-btn--primary">Download CheckScript</Link>
          </div>
        </div>
      </section>
    </SEOPageLayout>
  );
}
